import { useDesignMaxTheme } from "@/packages";
import { useGetRoom, type RoomDetailInfoResponse } from "@/shared/server";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useInView } from "react-intersection-observer";
import { RoomDescription } from "./components";

export const RoomDetail = ({ roomIdx }: { roomIdx: string }) => {
    const { data } = useGetRoom<RoomDetailInfoResponse>({ section: "detail", roomIdx });
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });

    return data ? (
        <Box ref={ref} position="relative" w="100%" h="100dvh" background="#333" p={isMobile ? "64px 0 24px 0" : "0"}>
            <RoomDescription inView={inView} roomDetailInfo={data.roomDetailInfo} />
        </Box>
    ) : (
        <Center w="100" h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
